import React from 'react';
import { statusLabel, statusColor } from '../../utils/statusUtils';

export default function StatusBadge({ status }) {
  return (
    <span className="status-badge" style={{ background: statusColor(status) }}>
      {statusLabel(status)}
    </span>
  );
}
